import { default as baby_45meal_45deliveryFgVylDMZR6Meta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/baby-meal-delivery.vue?macro=true";
import { default as cancellation_45processinglVQmjxoJR1Meta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/cancellation-processing.vue?macro=true";
import { default as contact_45usxrTQ9yRr4ZMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/contact-us.vue?macro=true";
import { default as cookie_45preferencesPHUjQFuN64Meta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/cookie-preferences.vue?macro=true";
import { default as faqt0EQkl140DMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/faq.vue?macro=true";
import { default as food_45nutritionhl8jiMtwHDMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/food-nutrition.vue?macro=true";
import { default as indexrdlFsgOvuFMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/gift-cards/index.vue?macro=true";
import { default as gluten_45free_45meals_45for_45kidszOPcjn36hlMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/gluten-free-meals-for-kids.vue?macro=true";
import { default as how_45it_45worksqb5MXhkazZMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/how-it-works.vue?macro=true";
import { default as index1XIqAeIt2TMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/index.vue?macro=true";
import { default as maintenanceLLlcRJpOfpMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/maintenance.vue?macro=true";
import { default as meal_45delivery_45for_45kidsaymDa5iLuxMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/meal-delivery-for-kids.vue?macro=true";
import { default as meal_45delivery_45for_45picky_45eatersk7LGhEkOyyMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/meal-delivery-for-picky-eaters.vue?macro=true";
import { default as _91slug_93IvpRwe4GeUMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/menus/[slug].vue?macro=true";
import { default as indexb8uKVRd4USMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/menus/index.vue?macro=true";
import { default as offer_45accepted_45processingorr01VCzoHMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/offer-accepted-processing.vue?macro=true";
import { default as indexH906FQqlzHMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/checkout/index.vue?macro=true";
import { default as indexPW6OVbtoyGMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/checkout/success/index.vue?macro=true";
import { default as indexITw4XMZG47Meta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/forgot-password/index.vue?macro=true";
import { default as indexwMbBgDfdS6Meta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/login/index.vue?macro=true";
import { default as indexEHM7JCMbCSMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/plans/index.vue?macro=true";
import { default as indexuea8pp5wtKMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/reset-password/index.vue?macro=true";
import { default as indexrdwLgEklFnMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/signup/index.vue?macro=true";
import { default as indexJ6XkV6xBvhMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/verification/index.vue?macro=true";
import { default as our_45storyvRCCfk0cwDMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/our-story.vue?macro=true";
import { default as packagingrpWoKgv2crMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/packaging.vue?macro=true";
import { default as pausing_45processing994Z9W7ydwMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/pausing-processing.vue?macro=true";
import { default as privacy_45policyBQSeNYHUZFMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/privacy-policy.vue?macro=true";
import { default as reactivateBUAF9NVLUcMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/reactivate.vue?macro=true";
import { default as safetyRkV34OCYGPMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/safety.vue?macro=true";
import { default as termsIBCPTxuBapMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/terms.vue?macro=true";
import { default as toddler_45meal_45deliveryaGdjuC6WhpMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/toddler-meal-delivery.vue?macro=true";
import { default as vegetarian_45meals_45for_45kidsGtzs1s0Z6zMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/vegetarian-meals-for-kids.vue?macro=true";
import { default as what_45we_45stand_45forRy9XsZrlMvMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/what-we-stand-for.vue?macro=true";
import { default as indexImbXZj78CEMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/blog/index.vue?macro=true";
import { default as indexiG0bU4FstBMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/blog/search/index.vue?macro=true";
import { default as _91slug_93fxiI5Y4sQMMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/blog/[slug].vue?macro=true";
import { default as _91number_93vqCihlvwx3Meta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/blog/page/[number].vue?macro=true";
import { default as _91number_934BN2vHGxQFMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/blog/category/[slug]/page/[number].vue?macro=true";
import { default as indexoANCiXlfGwMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/blog/category/[slug]/index.vue?macro=true";
import { default as indexrLAauK6oEBMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/news/index.vue?macro=true";
import { default as indexhcCEekqfiuMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/announcements/index.vue?macro=true";
import { default as _91slug_93mQbrijd6UGMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/announcements/[slug].vue?macro=true";
import { default as component_45stubqVRDuW6mcPMeta } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubqVRDuW6mcP } from "/home/runner/work/nurturelife-marketing/nurturelife-marketing/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: baby_45meal_45deliveryFgVylDMZR6Meta?.name ?? "baby-meal-delivery",
    path: baby_45meal_45deliveryFgVylDMZR6Meta?.path ?? "/baby-meal-delivery",
    meta: baby_45meal_45deliveryFgVylDMZR6Meta || {},
    alias: baby_45meal_45deliveryFgVylDMZR6Meta?.alias || [],
    redirect: baby_45meal_45deliveryFgVylDMZR6Meta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/baby-meal-delivery.vue").then(m => m.default || m)
  },
  {
    name: cancellation_45processinglVQmjxoJR1Meta?.name ?? "cancellation-processing",
    path: cancellation_45processinglVQmjxoJR1Meta?.path ?? "/cancellation-processing",
    meta: cancellation_45processinglVQmjxoJR1Meta || {},
    alias: cancellation_45processinglVQmjxoJR1Meta?.alias || [],
    redirect: cancellation_45processinglVQmjxoJR1Meta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/cancellation-processing.vue").then(m => m.default || m)
  },
  {
    name: contact_45usxrTQ9yRr4ZMeta?.name ?? "contact-us",
    path: contact_45usxrTQ9yRr4ZMeta?.path ?? "/contact-us",
    meta: contact_45usxrTQ9yRr4ZMeta || {},
    alias: contact_45usxrTQ9yRr4ZMeta?.alias || [],
    redirect: contact_45usxrTQ9yRr4ZMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/contact-us.vue").then(m => m.default || m)
  },
  {
    name: cookie_45preferencesPHUjQFuN64Meta?.name ?? "cookie-preferences",
    path: cookie_45preferencesPHUjQFuN64Meta?.path ?? "/cookie-preferences",
    meta: cookie_45preferencesPHUjQFuN64Meta || {},
    alias: cookie_45preferencesPHUjQFuN64Meta?.alias || [],
    redirect: cookie_45preferencesPHUjQFuN64Meta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/cookie-preferences.vue").then(m => m.default || m)
  },
  {
    name: faqt0EQkl140DMeta?.name ?? "faq",
    path: faqt0EQkl140DMeta?.path ?? "/faq",
    meta: faqt0EQkl140DMeta || {},
    alias: faqt0EQkl140DMeta?.alias || [],
    redirect: faqt0EQkl140DMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: food_45nutritionhl8jiMtwHDMeta?.name ?? "food-nutrition",
    path: food_45nutritionhl8jiMtwHDMeta?.path ?? "/food-nutrition",
    meta: food_45nutritionhl8jiMtwHDMeta || {},
    alias: food_45nutritionhl8jiMtwHDMeta?.alias || [],
    redirect: food_45nutritionhl8jiMtwHDMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/food-nutrition.vue").then(m => m.default || m)
  },
  {
    name: indexrdlFsgOvuFMeta?.name ?? "gift-cards",
    path: indexrdlFsgOvuFMeta?.path ?? "/gift-cards",
    meta: indexrdlFsgOvuFMeta || {},
    alias: indexrdlFsgOvuFMeta?.alias || [],
    redirect: indexrdlFsgOvuFMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/gift-cards/index.vue").then(m => m.default || m)
  },
  {
    name: gluten_45free_45meals_45for_45kidszOPcjn36hlMeta?.name ?? "gluten-free-meals-for-kids",
    path: gluten_45free_45meals_45for_45kidszOPcjn36hlMeta?.path ?? "/gluten-free-meals-for-kids",
    meta: gluten_45free_45meals_45for_45kidszOPcjn36hlMeta || {},
    alias: gluten_45free_45meals_45for_45kidszOPcjn36hlMeta?.alias || [],
    redirect: gluten_45free_45meals_45for_45kidszOPcjn36hlMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/gluten-free-meals-for-kids.vue").then(m => m.default || m)
  },
  {
    name: how_45it_45worksqb5MXhkazZMeta?.name ?? "how-it-works",
    path: how_45it_45worksqb5MXhkazZMeta?.path ?? "/how-it-works",
    meta: how_45it_45worksqb5MXhkazZMeta || {},
    alias: how_45it_45worksqb5MXhkazZMeta?.alias || [],
    redirect: how_45it_45worksqb5MXhkazZMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/how-it-works.vue").then(m => m.default || m)
  },
  {
    name: index1XIqAeIt2TMeta?.name ?? "index",
    path: index1XIqAeIt2TMeta?.path ?? "/",
    meta: index1XIqAeIt2TMeta || {},
    alias: index1XIqAeIt2TMeta?.alias || [],
    redirect: index1XIqAeIt2TMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/index.vue").then(m => m.default || m)
  },
  {
    name: maintenanceLLlcRJpOfpMeta?.name ?? "maintenance",
    path: maintenanceLLlcRJpOfpMeta?.path ?? "/maintenance",
    meta: maintenanceLLlcRJpOfpMeta || {},
    alias: maintenanceLLlcRJpOfpMeta?.alias || [],
    redirect: maintenanceLLlcRJpOfpMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/maintenance.vue").then(m => m.default || m)
  },
  {
    name: meal_45delivery_45for_45kidsaymDa5iLuxMeta?.name ?? "meal-delivery-for-kids",
    path: meal_45delivery_45for_45kidsaymDa5iLuxMeta?.path ?? "/meal-delivery-for-kids",
    meta: meal_45delivery_45for_45kidsaymDa5iLuxMeta || {},
    alias: meal_45delivery_45for_45kidsaymDa5iLuxMeta?.alias || [],
    redirect: meal_45delivery_45for_45kidsaymDa5iLuxMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/meal-delivery-for-kids.vue").then(m => m.default || m)
  },
  {
    name: meal_45delivery_45for_45picky_45eatersk7LGhEkOyyMeta?.name ?? "meal-delivery-for-picky-eaters",
    path: meal_45delivery_45for_45picky_45eatersk7LGhEkOyyMeta?.path ?? "/meal-delivery-for-picky-eaters",
    meta: meal_45delivery_45for_45picky_45eatersk7LGhEkOyyMeta || {},
    alias: meal_45delivery_45for_45picky_45eatersk7LGhEkOyyMeta?.alias || [],
    redirect: meal_45delivery_45for_45picky_45eatersk7LGhEkOyyMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/meal-delivery-for-picky-eaters.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93IvpRwe4GeUMeta?.name ?? "menus-slug",
    path: _91slug_93IvpRwe4GeUMeta?.path ?? "/menus/:slug()",
    meta: _91slug_93IvpRwe4GeUMeta || {},
    alias: _91slug_93IvpRwe4GeUMeta?.alias || [],
    redirect: _91slug_93IvpRwe4GeUMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/menus/[slug].vue").then(m => m.default || m)
  },
  {
    name: indexb8uKVRd4USMeta?.name ?? "menus",
    path: indexb8uKVRd4USMeta?.path ?? "/menus",
    meta: indexb8uKVRd4USMeta || {},
    alias: indexb8uKVRd4USMeta?.alias || [],
    redirect: indexb8uKVRd4USMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/menus/index.vue").then(m => m.default || m)
  },
  {
    name: offer_45accepted_45processingorr01VCzoHMeta?.name ?? "offer-accepted-processing",
    path: offer_45accepted_45processingorr01VCzoHMeta?.path ?? "/offer-accepted-processing",
    meta: offer_45accepted_45processingorr01VCzoHMeta || {},
    alias: offer_45accepted_45processingorr01VCzoHMeta?.alias || [],
    redirect: offer_45accepted_45processingorr01VCzoHMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/offer-accepted-processing.vue").then(m => m.default || m)
  },
  {
    name: indexH906FQqlzHMeta?.name ?? "onboarding-checkout",
    path: indexH906FQqlzHMeta?.path ?? "/onboarding/checkout",
    meta: indexH906FQqlzHMeta || {},
    alias: indexH906FQqlzHMeta?.alias || [],
    redirect: indexH906FQqlzHMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/checkout/index.vue").then(m => m.default || m)
  },
  {
    name: indexPW6OVbtoyGMeta?.name ?? "onboarding-checkout-success",
    path: indexPW6OVbtoyGMeta?.path ?? "/onboarding/checkout/success",
    meta: indexPW6OVbtoyGMeta || {},
    alias: indexPW6OVbtoyGMeta?.alias || [],
    redirect: indexPW6OVbtoyGMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/checkout/success/index.vue").then(m => m.default || m)
  },
  {
    name: indexITw4XMZG47Meta?.name ?? "onboarding-forgot-password",
    path: indexITw4XMZG47Meta?.path ?? "/onboarding/forgot-password",
    meta: indexITw4XMZG47Meta || {},
    alias: indexITw4XMZG47Meta?.alias || [],
    redirect: indexITw4XMZG47Meta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/forgot-password/index.vue").then(m => m.default || m)
  },
  {
    name: indexwMbBgDfdS6Meta?.name ?? "onboarding-login",
    path: indexwMbBgDfdS6Meta?.path ?? "/onboarding/login",
    meta: indexwMbBgDfdS6Meta || {},
    alias: indexwMbBgDfdS6Meta?.alias || [],
    redirect: indexwMbBgDfdS6Meta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/login/index.vue").then(m => m.default || m)
  },
  {
    name: indexEHM7JCMbCSMeta?.name ?? "onboarding-plans",
    path: indexEHM7JCMbCSMeta?.path ?? "/onboarding/plans",
    meta: indexEHM7JCMbCSMeta || {},
    alias: indexEHM7JCMbCSMeta?.alias || [],
    redirect: indexEHM7JCMbCSMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/plans/index.vue").then(m => m.default || m)
  },
  {
    name: indexuea8pp5wtKMeta?.name ?? "onboarding-reset-password",
    path: indexuea8pp5wtKMeta?.path ?? "/onboarding/reset-password",
    meta: indexuea8pp5wtKMeta || {},
    alias: indexuea8pp5wtKMeta?.alias || [],
    redirect: indexuea8pp5wtKMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/reset-password/index.vue").then(m => m.default || m)
  },
  {
    name: indexrdwLgEklFnMeta?.name ?? "onboarding-signup",
    path: indexrdwLgEklFnMeta?.path ?? "/onboarding/signup",
    meta: indexrdwLgEklFnMeta || {},
    alias: indexrdwLgEklFnMeta?.alias || [],
    redirect: indexrdwLgEklFnMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/signup/index.vue").then(m => m.default || m)
  },
  {
    name: indexJ6XkV6xBvhMeta?.name ?? "onboarding-verification",
    path: indexJ6XkV6xBvhMeta?.path ?? "/onboarding/verification",
    meta: indexJ6XkV6xBvhMeta || {},
    alias: indexJ6XkV6xBvhMeta?.alias || [],
    redirect: indexJ6XkV6xBvhMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/onboarding/verification/index.vue").then(m => m.default || m)
  },
  {
    name: our_45storyvRCCfk0cwDMeta?.name ?? "our-story",
    path: our_45storyvRCCfk0cwDMeta?.path ?? "/our-story",
    meta: our_45storyvRCCfk0cwDMeta || {},
    alias: our_45storyvRCCfk0cwDMeta?.alias || [],
    redirect: our_45storyvRCCfk0cwDMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/our-story.vue").then(m => m.default || m)
  },
  {
    name: packagingrpWoKgv2crMeta?.name ?? "packaging",
    path: packagingrpWoKgv2crMeta?.path ?? "/packaging",
    meta: packagingrpWoKgv2crMeta || {},
    alias: packagingrpWoKgv2crMeta?.alias || [],
    redirect: packagingrpWoKgv2crMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/packaging.vue").then(m => m.default || m)
  },
  {
    name: pausing_45processing994Z9W7ydwMeta?.name ?? "pausing-processing",
    path: pausing_45processing994Z9W7ydwMeta?.path ?? "/pausing-processing",
    meta: pausing_45processing994Z9W7ydwMeta || {},
    alias: pausing_45processing994Z9W7ydwMeta?.alias || [],
    redirect: pausing_45processing994Z9W7ydwMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/pausing-processing.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policyBQSeNYHUZFMeta?.name ?? "privacy-policy",
    path: privacy_45policyBQSeNYHUZFMeta?.path ?? "/privacy-policy",
    meta: privacy_45policyBQSeNYHUZFMeta || {},
    alias: privacy_45policyBQSeNYHUZFMeta?.alias || [],
    redirect: privacy_45policyBQSeNYHUZFMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/privacy-policy.vue").then(m => m.default || m)
  },
  {
    name: reactivateBUAF9NVLUcMeta?.name ?? "reactivate",
    path: reactivateBUAF9NVLUcMeta?.path ?? "/reactivate",
    meta: reactivateBUAF9NVLUcMeta || {},
    alias: reactivateBUAF9NVLUcMeta?.alias || [],
    redirect: reactivateBUAF9NVLUcMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/reactivate.vue").then(m => m.default || m)
  },
  {
    name: safetyRkV34OCYGPMeta?.name ?? "safety",
    path: safetyRkV34OCYGPMeta?.path ?? "/safety",
    meta: safetyRkV34OCYGPMeta || {},
    alias: safetyRkV34OCYGPMeta?.alias || [],
    redirect: safetyRkV34OCYGPMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/safety.vue").then(m => m.default || m)
  },
  {
    name: termsIBCPTxuBapMeta?.name ?? "terms",
    path: termsIBCPTxuBapMeta?.path ?? "/terms",
    meta: termsIBCPTxuBapMeta || {},
    alias: termsIBCPTxuBapMeta?.alias || [],
    redirect: termsIBCPTxuBapMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/terms.vue").then(m => m.default || m)
  },
  {
    name: toddler_45meal_45deliveryaGdjuC6WhpMeta?.name ?? "toddler-meal-delivery",
    path: toddler_45meal_45deliveryaGdjuC6WhpMeta?.path ?? "/toddler-meal-delivery",
    meta: toddler_45meal_45deliveryaGdjuC6WhpMeta || {},
    alias: toddler_45meal_45deliveryaGdjuC6WhpMeta?.alias || [],
    redirect: toddler_45meal_45deliveryaGdjuC6WhpMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/toddler-meal-delivery.vue").then(m => m.default || m)
  },
  {
    name: vegetarian_45meals_45for_45kidsGtzs1s0Z6zMeta?.name ?? "vegetarian-meals-for-kids",
    path: vegetarian_45meals_45for_45kidsGtzs1s0Z6zMeta?.path ?? "/vegetarian-meals-for-kids",
    meta: vegetarian_45meals_45for_45kidsGtzs1s0Z6zMeta || {},
    alias: vegetarian_45meals_45for_45kidsGtzs1s0Z6zMeta?.alias || [],
    redirect: vegetarian_45meals_45for_45kidsGtzs1s0Z6zMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/vegetarian-meals-for-kids.vue").then(m => m.default || m)
  },
  {
    name: what_45we_45stand_45forRy9XsZrlMvMeta?.name ?? "what-we-stand-for",
    path: what_45we_45stand_45forRy9XsZrlMvMeta?.path ?? "/what-we-stand-for",
    meta: what_45we_45stand_45forRy9XsZrlMvMeta || {},
    alias: what_45we_45stand_45forRy9XsZrlMvMeta?.alias || [],
    redirect: what_45we_45stand_45forRy9XsZrlMvMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/pages/what-we-stand-for.vue").then(m => m.default || m)
  },
  {
    name: indexImbXZj78CEMeta?.name ?? "blog",
    path: indexImbXZj78CEMeta?.path ?? "/blog/",
    meta: indexImbXZj78CEMeta || {},
    alias: indexImbXZj78CEMeta?.alias || [],
    redirect: indexImbXZj78CEMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: indexiG0bU4FstBMeta?.name ?? "blog-search",
    path: indexiG0bU4FstBMeta?.path ?? "/blog/search/",
    meta: indexiG0bU4FstBMeta || {},
    alias: indexiG0bU4FstBMeta?.alias || [],
    redirect: indexiG0bU4FstBMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/blog/search/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93fxiI5Y4sQMMeta?.name ?? "blog-post",
    path: _91slug_93fxiI5Y4sQMMeta?.path ?? "/blog/:slug/",
    meta: _91slug_93fxiI5Y4sQMMeta || {},
    alias: _91slug_93fxiI5Y4sQMMeta?.alias || [],
    redirect: _91slug_93fxiI5Y4sQMMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91number_93vqCihlvwx3Meta?.name ?? "blog-page",
    path: _91number_93vqCihlvwx3Meta?.path ?? "/blog/page/:number/",
    meta: _91number_93vqCihlvwx3Meta || {},
    alias: _91number_93vqCihlvwx3Meta?.alias || [],
    redirect: _91number_93vqCihlvwx3Meta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/blog/page/[number].vue").then(m => m.default || m)
  },
  {
    name: _91number_934BN2vHGxQFMeta?.name ?? "blog-category-page-number",
    path: _91number_934BN2vHGxQFMeta?.path ?? "/blog/category/:slug/page/:number/",
    meta: _91number_934BN2vHGxQFMeta || {},
    alias: _91number_934BN2vHGxQFMeta?.alias || [],
    redirect: _91number_934BN2vHGxQFMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/blog/category/[slug]/page/[number].vue").then(m => m.default || m)
  },
  {
    name: indexoANCiXlfGwMeta?.name ?? "blog-category-page",
    path: indexoANCiXlfGwMeta?.path ?? "/blog/category/:slug/",
    meta: indexoANCiXlfGwMeta || {},
    alias: indexoANCiXlfGwMeta?.alias || [],
    redirect: indexoANCiXlfGwMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/blog/category/[slug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexrLAauK6oEBMeta?.name ?? "news",
    path: indexrLAauK6oEBMeta?.path ?? "/news/",
    meta: indexrLAauK6oEBMeta || {},
    alias: indexrLAauK6oEBMeta?.alias || [],
    redirect: indexrLAauK6oEBMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexrLAauK6oEBMeta?.name ?? "news-page",
    path: indexrLAauK6oEBMeta?.path ?? "/news/page/:number/",
    meta: indexrLAauK6oEBMeta || {},
    alias: indexrLAauK6oEBMeta?.alias || [],
    redirect: indexrLAauK6oEBMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: indexhcCEekqfiuMeta?.name ?? "announcements",
    path: indexhcCEekqfiuMeta?.path ?? "/announcements/",
    meta: indexhcCEekqfiuMeta || {},
    alias: indexhcCEekqfiuMeta?.alias || [],
    redirect: indexhcCEekqfiuMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/announcements/index.vue").then(m => m.default || m)
  },
  {
    name: indexhcCEekqfiuMeta?.name ?? "announcements-page",
    path: indexhcCEekqfiuMeta?.path ?? "/announcements/page/:number/",
    meta: indexhcCEekqfiuMeta || {},
    alias: indexhcCEekqfiuMeta?.alias || [],
    redirect: indexhcCEekqfiuMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/announcements/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93mQbrijd6UGMeta?.name ?? "announcement-post",
    path: _91slug_93mQbrijd6UGMeta?.path ?? "/announcements/:slug/",
    meta: _91slug_93mQbrijd6UGMeta || {},
    alias: _91slug_93mQbrijd6UGMeta?.alias || [],
    redirect: _91slug_93mQbrijd6UGMeta?.redirect,
    component: () => import("/home/runner/work/nurturelife-marketing/nurturelife-marketing/modules/content/pages/announcements/[slug].vue").then(m => m.default || m)
  },
  {
    name: component_45stubqVRDuW6mcPMeta?.name ?? undefined,
    path: component_45stubqVRDuW6mcPMeta?.path ?? "/onboarding",
    meta: component_45stubqVRDuW6mcPMeta || {},
    alias: component_45stubqVRDuW6mcPMeta?.alias || [],
    redirect: component_45stubqVRDuW6mcPMeta?.redirect,
    component: component_45stubqVRDuW6mcP
  }
]